<template>
  <div id="contact">
    <div class="container">
      <div class="row reversing">
        <div class="col-lg-6">
          <div class="using">
            <h3>Contact us</h3>
            <p>
              Do you have any questions or enquiries? Do not hesitate to reach out to us.
            </p>
          </div>
          <div class="stating">
            <form>
              <div class="form-group mb-2">
                <label for="fname">Full name</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="John Doe."
                />
              </div>
              <div class="form-group mb-2">
                <label for="email" class="editer">Email</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="mailat@example.com"
                />
              </div>
              <div class="form-group mb-2">
                <label for="message" class="editer">Message</label>
                <textarea
                  placeholder="your message"
                  class="form-control"
                ></textarea>
              </div>
              <div class="sub">
                <button class="submit">Submit</button>
              </div>
            </form>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="contact-image">
            <img src="../assets/Images/contact.png" alt="" class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
* {
  font-family: "Inter", sans-serif;
}

#contact {
  background: #f9f9f9;
}
.contact-image img {
  width: 667px;
  height: 538px;
}
.using h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 39px;
  color: #000000;
}
.using p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #404040;
}
.link {
  text-decoration: none;
  font-weight: bold;
}
.button {
  margin-top: 2rem;
}
.contact-image {
  margin-top: 1rem;
}
.sub {
  margin-top: 2.6rem;
}
/* form styling */
.form-control {
  padding: 12px;
  background: #ffffff;
  border-radius: 8px;
  border: none !important;
  border: transparent !important;
}
label {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: #1f1f1f;
  margin-bottom: 0.4rem;
}

.editer {
  margin-top: 0.5rem;
}
.forming {
  width: 437px;
  height: 105px;
  background: #ffffff;
  border-radius: 8px;
  border: none !important;
}
.submit {
  width: 150px;
  height: 48px;
  background: #335ca6;
  border-radius: 8px;
  color: #f9f9f9;
  border: none !important;
}

.stating .form-control {
  border: 2px solid #ccc !important;
}

/* for responsive design */

@media screen and (max-width: 768px) {
  .rem {
    margin-bottom: 1.9rem;
  }
  .button {
    position: relative;
    top: 528px;
    display: flex;
    justify-content: center;
  }

  .reversing {
    flex-direction: column-reverse;
  }

  .flexing {
    margin-top: -54px;
    margin-bottom: 37px;
  }

  .personal {
    width: 100%;
  }

  .forming {
    width: 100%;
  }

  .contact-image img {
    height: 328px;
    margin-bottom: 16px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    width: 725px;
  }
}

@media screen and (max-width: 425px) {
  /* for small screen forms and button */
  .personal {
    width: 100%;
    height: 67px;
  }

  .stating {
    padding: 0px 10px;
  }
  /* .forming {
    width: 590px;
    }    */
  .sub {
    margin-top: 27px;
  }
  .contact-image img {
    width: 667px;
    height: 300px;
    padding: 0 8px;
  }

  .using {
    margin-top: 16px;
    padding: 0 8px;
  }

  .reversing {
    flex-direction: column-reverse;
  }
}
@media screen and (max-width: 375px) {
}
@media screen and (max-width: 320px) {
}
</style>